import { userNextRouteTransitions } from 'hooks/useNextRouteTransitions';
import { useRouter } from 'next/router';
import { ListPageFormTypeEnum } from '../types';

export const useListPageModalNavigation = () => {
  const router = useRouter();
  const { navigateToOnboarding } = userNextRouteTransitions();
  const isStepInRouterQuery = 'step' in router.query;
  const isFormTypeInRouterQuery = 'formType' in router.query;
  const formTypeParam = router.query?.formType ?? ListPageFormTypeEnum.Unassisted;
  const isAssistedSetUp = formTypeParam === ListPageFormTypeEnum.Assisted;

  // This variable is used to derive the form type from the formTypeParam. The formTypeParam returns a string which cannot be used an
  // an argument elsewhere.
  const currentForm = isAssistedSetUp ? ListPageFormTypeEnum.Assisted : ListPageFormTypeEnum.Unassisted;
  const step = router.query?.step ? Number(router.query.step) : 0;

  const pushRoot = (step: number, formType: ListPageFormTypeEnum) => {
    router.push(
      {
        pathname: router.pathname,
        query: { step, formType },
      },
      undefined,
      { shallow: true },
    );
  };

  const pushDefaultUrl = () => pushRoot(0, ListPageFormTypeEnum.Unassisted);

  const pushAssistedUrl = () => pushRoot(0, ListPageFormTypeEnum.Assisted);

  const pushUnassistedUrl = () => pushRoot(0, ListPageFormTypeEnum.Unassisted);

  const pushNextStep = () => pushRoot(step + 1, currentForm);
  // TODO - use this function once we figure out the css routing issue. We cannot
  // go to another page without using the location.href = ... as this the only
  // way to maintain our styling
  // const pushOnboarding = (property_id: number) => {
  //   router.push({
  //     pathname: `${OwnerRoutesEnum.onboarding}/${property_id}${OnboardingRoutesEnum.onboardingRequired}`,
  //     query: { step: 0, isAssistedSetUp },
  //   });
  // };

  const pushOnboarding = (property_id: number) => {
    navigateToOnboarding(property_id, isAssistedSetUp);
  };

  return {
    pushDefaultUrl,
    pushAssistedUrl,
    pushUnassistedUrl,
    pushNextStep,
    pushOnboarding,
    isStepInRouterQuery,
    isFormTypeInRouterQuery,
    isAssistedSetUp,
    step,
  };
};
